<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="7">
      <v-card class="home pa-5" outlined>
        <v-alert type="info" class="headline" border="left" dense outlined text
          >{{ getShopTitle }} is undergoing temporary maintenance. Please check
          back in a moment. Thanks.</v-alert
        >
        <v-card-text>
          <h2 class="black--text mt-4">Have a question?</h2>
          <p class="title">
            Email us at
            <a
              class="email-link d-inline-block"
              :href="`mailto:${getShopDetail('Contact Email')}`"
              >{{ getShopDetail('Contact Email') }}</a
            >
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MaintenanceModeView',
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters('shop', [
      'getShopDetail',
      'getShopTitle',
      'getIsMaintenanceModeOn',
    ]),
  },
  watch: {
    getIsMaintenanceModeOn: {
      handler(val) {
        if (!val) {
          this.$router.push({ name: 'Home' })
        }
      },
      immediate: true,
    },
  },
}
</script>
